import pianist1 from '@/components/CRM/Accompaniment/pianists/pianist1';
import pianist2 from '@/components/CRM/Accompaniment/pianists/pianist2';

export default [
  pianist1,
  pianist2
];
